<app-loader [isLoading]="isLoading"></app-loader>

<div class="header">
    <div class="top">
        <a [routerLink]="returnLink">
            <h3>{{ breadcrumbTitle }} /</h3>
            <div class="breadcrumb">
                <mat-icon svgIcon="arrow back"></mat-icon>
                <h2>{{ isEditMode ? (protocol.name || 'Editar protocolo') : 'Añadir protocolo' }}</h2>
            </div>
        </a>
    </div>
</div>

<div class="content">
    <div class="general-form">
        <h4>Información del protocolo</h4>
        <form [formGroup]="protocolForm">
            <h5>NOMBRE:</h5>
            <mat-form-field appearance="outline">
                <input type="text" matInput placeholder="Nombre del protocolo" formControlName="name">
                @if (protocolForm.get('name')?.invalid && protocolForm.get('name')?.touched) {
                <mat-error>
                    El nombre es requerido
                </mat-error>
                }
            </mat-form-field>

            <mat-divider></mat-divider>

            <h5>CÓDIGO:</h5>
            <mat-form-field appearance="outline">
                <input type="text" matInput placeholder="Código del protocolo" formControlName="code">
                @if (protocolForm.get('code')?.invalid && protocolForm.get('code')?.touched) {
                <mat-error>
                    El código es requerido
                </mat-error>
                }
            </mat-form-field>

            <mat-divider></mat-divider>


            <h5>DESCRIPCIÓN:</h5>
            <mat-form-field appearance="outline" id="area">
                <textarea matInput placeholder="Descripción del protocolo" formControlName="description"
                    rows="5"></textarea>
                @if (protocolForm.get('description')?.invalid && protocolForm.get('description')?.touched) {
                <mat-error>
                    La descripción es requerida
                </mat-error>
                }
            </mat-form-field>

            <div class="options-row">
                <mat-checkbox formControlName="enabled">Habilitado</mat-checkbox>
            </div>
        </form>
    </div>


    <!-- Rule Groups Section -->
    @for (group of ruleGroups; track $index) {
    <div class="rule-group-container">
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    {{ $index + 1 }}. {{ group.name || '[Grupo de reglas]' }}
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="rule-group-content">
                <!-- Group Configuration Button -->
                <div class="group-config-row">
                    <span class="operator-message">
                        <mat-icon>info</mat-icon>
                        {{ getOperatorLabel(group.operator) }}</span>
                    <button mat-button class="config-btn" type="button" (click)="editRuleGroup(group, $index)">
                        Configuración del grupo
                    </button>
                </div>
                <mat-divider></mat-divider>


                <!-- Rules in this group -->
                @for (rule of group.rules; track $index; let ruleIndex = $index; let isLast = $last; let isFirst =
                $first) {
                <div class="tree-item" [class.is-last]="isLast" [class.is-first]="isFirst"
                    [class.is-only]="isFirst && isLast">
                    <div class="tree-line"></div>
                    <div class="tree-branch"></div>
                    <div class="rule-container">
                        <div class="field-row">
                            <div class="field-with-delete">
                                <h5>SELECCIONE UN TIPO DE REGLA</h5>
                                <mat-form-field appearance="outline">
                                    <mat-select [(ngModel)]="rule.rule_type" placeholder="Seleccione un tipo">
                                        @for (type of ruleTypeChoices; track type.value) {
                                        <mat-option [value]="type.value">{{ type.label }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                                <button mat-button class="delete-btn" type="button"
                                    (click)="removeRule(group, ruleIndex)">
                                    Eliminar
                                </button>
                            </div>
                        </div>

                        <!-- Value field for numeric rules -->
                        @if (needsValueField(rule.rule_type)) {
                        <div class="field-row indented">
                            <h5>{{ getValueFieldLabel(rule.rule_type) }}</h5>
                            <mat-form-field appearance="outline" class="small-field">
                                <input matInput type="number" [(ngModel)]="rule.value" placeholder="0">
                            </mat-form-field>
                        </div>
                        }

                        <!-- Boolean field for single_days -->
                        @if (needsBooleanField(rule.rule_type)) {
                        <div class="field-row indented">
                            <mat-checkbox [(ngModel)]="rule.boolean_value">Días sueltos permitidos</mat-checkbox>
                        </div>
                        }

                        <!-- Date range fields -->
                        @if (needsDateRangeField(rule.rule_type)) {
                        <div class="field-row indented">
                            <h5>FECHA INICIAL Y FINAL DEL RANGO DE VACACIONES</h5>
                            <mat-form-field appearance="outline">
                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate [(ngModel)]="rule.date_range_start" placeholder="Fecha inicio">
                                    <input matEndDate [(ngModel)]="rule.date_range_end" placeholder="Fecha fin">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>
                        </div>
                        }

                        <!-- Error message field -->
                        @if (rule.rule_type) {
                        <div class="field-row indented">
                            <h5>MENSAJE DE ERROR</h5>
                            <mat-form-field appearance="outline">
                                <input matInput [(ngModel)]="rule.error_message"
                                    placeholder="Mensaje de error personalizado">
                            </mat-form-field>
                        </div>
                        <div class="field-row indented">
                            <mat-checkbox [(ngModel)]="rule.is_determinant">Es determinante</mat-checkbox>
                        </div>
                        }
                    </div>
                </div>
                }

                <!-- Recursive child groups -->
                <ng-container
                    *ngTemplateOutlet="childGroupTemplate; context: { $implicit: group.child_groups, parent: group, depth: 1, numberPrefix: ($index + 1) + '.' }">
                </ng-container>

                <!-- Action buttons -->
                <div class="rule-group-actions">
                    <button mat-button class="cancel" type="button" (click)="addRule(group)">
                        Nueva regla +
                    </button>
                    <button mat-button class="cancel" type="button" (click)="addChildGroup(group)">
                        Nuevo subgrupo de reglas +
                    </button>
                </div>
            </div>
        </mat-expansion-panel>
    </div>
    }

    <!-- Template for recursive child groups -->
    <ng-template #childGroupTemplate let-childGroups let-parent="parent" let-depth="depth"
        let-numberPrefix="numberPrefix">
        @for (childGroup of childGroups; track $index; let childIndex = $index; let isLast = $last; let isFirst =
        $first) {
        <div class="child-group-container">
            <div class="subgroup-container">
                <mat-expansion-panel [expanded]="true">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{ numberPrefix }}{{ childIndex + 1 }}. {{ childGroup.name || '[Subgrupo de reglas]' }}
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="rule-group-content">
                        <!-- Child Group Configuration Button -->
                        <div class="group-config-row">
                            <span class="operator-message">
                                <mat-icon>info</mat-icon>
                                {{ getOperatorLabel(childGroup.operator) }}</span>
                            <button mat-button class="config-btn" type="button"
                                (click)="editChildGroup(childGroup, parent, childIndex)">
                                Configuración del grupo
                            </button>
                        </div>
                        <mat-divider></mat-divider>


                        <!-- Rules in child group -->
                        @for (rule of childGroup.rules; track $index; let ruleIndex = $index; let isLast = $last; let
                        isFirst = $first) {
                        <div class="tree-item" [class.is-last]="isLast" [class.is-first]="isFirst"
                            [class.is-only]="isFirst && isLast">
                            <div class="tree-line"></div>
                            <div class="tree-branch"></div>
                            <div class="rule-container">
                                <div class="field-row">
                                    <div class="field-with-delete">
                                        <h5>SELECCIONE UN TIPO DE REGLA</h5>
                                        <mat-form-field appearance="outline">
                                            <mat-select [(ngModel)]="rule.rule_type" placeholder="Seleccione un tipo">
                                                @for (type of ruleTypeChoices; track type.value) {
                                                <mat-option [value]="type.value">{{ type.label }}</mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>
                                        <button mat-button class="delete-btn" type="button"
                                            (click)="removeRule(childGroup, ruleIndex)">
                                            Eliminar
                                        </button>
                                    </div>
                                </div>

                                @if (needsValueField(rule.rule_type)) {
                                <div class="field-row indented">
                                    <h5>{{ getValueFieldLabel(rule.rule_type) }}</h5>
                                    <mat-form-field appearance="outline" class="small-field">
                                        <input matInput type="number" [(ngModel)]="rule.value" placeholder="0">
                                    </mat-form-field>
                                </div>
                                }

                                @if (needsBooleanField(rule.rule_type)) {
                                <div class="field-row indented">
                                    <mat-checkbox [(ngModel)]="rule.boolean_value">Días sueltos
                                        permitidos</mat-checkbox>
                                </div>
                                }

                                @if (needsDateRangeField(rule.rule_type)) {
                                <div class="field-row indented">
                                    <h5>FECHA INICIAL Y FINAL DEL RANGO DE VACACIONES</h5>
                                    <mat-form-field appearance="outline">
                                        <mat-date-range-input [rangePicker]="childPicker">
                                            <input matStartDate [(ngModel)]="rule.date_range_start"
                                                placeholder="Fecha inicio">
                                            <input matEndDate [(ngModel)]="rule.date_range_end" placeholder="Fecha fin">
                                        </mat-date-range-input>
                                        <mat-datepicker-toggle matIconSuffix
                                            [for]="childPicker"></mat-datepicker-toggle>
                                        <mat-date-range-picker #childPicker></mat-date-range-picker>
                                    </mat-form-field>
                                </div>
                                }

                                @if (rule.rule_type) {
                                <div class="field-row indented">
                                    <h5>MENSAJE DE ERROR</h5>
                                    <mat-form-field appearance="outline">
                                        <input matInput [(ngModel)]="rule.error_message"
                                            placeholder="Mensaje de error personalizado">
                                    </mat-form-field>
                                </div>
                                <div class="field-row indented">
                                    <mat-checkbox [(ngModel)]="rule.is_determinant">Es determinante</mat-checkbox>
                                </div>
                                }
                            </div>
                        </div>
                        }

                        <!-- Recursive nested child groups -->
                        <ng-container
                            *ngTemplateOutlet="childGroupTemplate; context: { $implicit: childGroup.child_groups, parent: childGroup, depth: depth + 1, numberPrefix: numberPrefix + (childIndex + 1) + '.' }">
                        </ng-container>

                        <!-- Child group action buttons -->
                        <div class="rule-group-actions">
                            <button mat-button class="cancel" type="button" (click)="addRule(childGroup)">
                                Nueva regla +
                            </button>
                            <button mat-button class="cancel" type="button" (click)="addChildGroup(childGroup)">
                                Nuevo subgrupo de reglas +
                            </button>
                        </div>
                    </div>
                </mat-expansion-panel>
            </div>
        </div>
        }
    </ng-template>

    <div class="buttons">
        <button mat-button class="cancel" type="button" (click)="addRuleGroup()">
            Nuevo grupo de reglas +
        </button>
    </div>

    <mat-divider></mat-divider>

    <div class="buttons">
        <button mat-flat-button id="action" type="button" (click)="saveChanges()"
            [disabled]="isSubmitting || protocolForm.invalid">
            @if (isSubmitting) {
            {{ isEditMode ? 'Actualizando...' : 'Guardando...' }}
            } @else {
            {{ isEditMode ? 'Actualizar' : 'Guardar cambios' }}
            }
        </button>
        <!-- <button mat-flat-button id="action" type="button" (click)="simulate()">
            Simular
        </button> -->
        <button mat-flat-button id="delete" type="button" (click)="deleteProtocol()">
            Eliminar
        </button>
        <button mat-flat-button id="cancel" type="button" (click)="cancel()">Cancelar</button>
    </div>
</div>